/**
 * Typed error thrown when an incoming token's `jti` claim has already
 * been seen within the replay-store TTL window.
 *
 * Extends `S2SVerifyError` so downstream consumers can `instanceof`-
 * discriminate replay rejections from other verifier failures (e.g.
 * `S2STokenExpired`, `S2SAudienceMismatch`).
 *
 * Wire-stable detail code: `auth_jti_replayed` (auth-sdk middleware lens).
 */
import { S2SVerifyError } from "../verify/errors";

export class JtiReplayed extends S2SVerifyError {
  readonly jti: string;

  constructor(jti: string, cause?: unknown) {
    super(`jti already used: ${jti}`, cause);
    this.name = "JtiReplayed";
    this.jti = jti;
  }
}
